import React from 'react';
import { Box, Button, Card, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const SectionCard = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 1100,
  borderRadius: 16,
  boxShadow: '0 10px 30px rgba(0,0,0,0.08)'
}));

const VishingStep4 = ({ onFinish }) => (
  <Box sx={{ p: { xs: 2, md: 3 }, display: 'flex', justifyContent: 'center' }}>
    <SectionCard sx={{ p: 4, textAlign: 'center', background: 'linear-gradient(135deg, #E3F2FD 0%, #F3E5F5 100%)' }}>
      <EmojiEventsIcon sx={{ fontSize: 56, color: 'primary.main' }} />
      <Typography variant="h4" sx={{ fontWeight: 900, mt: 1 }}>
        You’re all set! 🎉
      </Typography>
      <Typography sx={{ mt: 1, color: 'text.secondary' }}>
        Your vishing campaign has been created. You can manage scenarios, voices, caller ID, and schedule from the dashboard.
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
        <Button variant="contained" onClick={onFinish}>
          Finish
        </Button>
      </Box>
    </SectionCard>
  </Box>
);

export default VishingStep4;
